import React, { Component } from 'react';
import { Link } from 'react-router';
import { Dialog } from "@blueprintjs/core";
import { Text } from 'components/tt-forms/common';
import { isEmpty, get } from 'lodash';
// import TextTruncate from 'react-text-truncate';

export default class RowItemDanhMucCuocThanhTraTrung extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    }
  }

  closeDialog() {
    this.setState({
      isOpen: false
    });
  }

  onOpenDialog() {
    this.setState({
      isOpen: true
    });
  }

  render() {
    const { count, namThanhTraXuLy } = this.props;
    const listSelectTTT = JSON.parse(localStorage.getItem('listSelectThanhTraTrung')) || [];
    const { doiTuongThanhTraTrung, cuocThanhTras, namThanhTra } = this.props.item;
    const onCheckDisable = () => {
      let onCheck = false;
      cuocThanhTras.map(item => {
        if (isEmpty(item.trangThaiXuLyTaiDonVi)) {
          onCheck = true;
        }
      });
      return onCheck;
    }
    const ListData = cuocThanhTras.map((item, index) => {
      if (index === 0) {
        return (
          <tr key={index}>
            <td rowSpan={cuocThanhTras.length} className='table-checkbox'>
              {
                namThanhTra === namThanhTraXuLy &&
                <label className="pt-control pt-checkbox pt-large">
                  <input
                    type="checkbox"
                    disabled={(!isEmpty(listSelectTTT) && listSelectTTT.includes(doiTuongThanhTraTrung.doiTuongThanhTraId)) || (!onCheckDisable())}
                    checked={!!this.props.item.selected}
                    className="pt-large"
                    onChange={this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item)}
                    name="checkboxKetQua"
                  />
                  <span className="pt-control-indicator"></span>
                </label>
              }
            </td>
            <td rowSpan={cuocThanhTras.length}>{count}</td>
            <td rowSpan={cuocThanhTras.length}>
              <Link className='txt-underline txt-regular' onClick={this.onOpenDialog.bind(this)}>{doiTuongThanhTraTrung.ten || ''}</Link>
              <Dialog
                isOpen={this.state.isOpen}
                onClose={this.closeDialog.bind(this)}
                title='Thông tin đối tượng thanh tra, kiểm tra'
                className="dialog-default wrap-block">
                <div className='row pl30 pr30 pt20'>
                  <Text
                    className="col-50 mb10"
                    label="Tên đối tượng:"
                    value={doiTuongThanhTraTrung.ten || ''} />
                  <Text
                    className="col-50 mb10"
                    label="Nhóm đối tượng:"
                    value={get(doiTuongThanhTraTrung, 'nhomDoiTuongThanhTraInfo.ten') || ''} />
                  <Text
                    className="col-50 mb10"
                    label="Huyện/TP:"
                    value={get(doiTuongThanhTraTrung, 'quanHuyenInfo.name')} />
                  <Text
                    className="col-50 mb10"
                    label="Phường/Xã:"
                    value={get(doiTuongThanhTraTrung, 'phuongXaInfo.name')} />
                  <Text
                    className="col-50 mb10"
                    label="Địa chỉ:"
                    value={doiTuongThanhTraTrung.diaChi || ''} />
                  <Text
                    className="col-50 mb10"
                    label="Số điện thoại:"
                    value={doiTuongThanhTraTrung.soDienThoai || ''} />
                  <Text
                    className="col-50 mb10"
                    label="Ghi chú:"
                    value={doiTuongThanhTraTrung.ghiChu || ''} />
                </div>
                <div className='row pl15 pr15'>
                  <span className='line-border mt5 mb0'></span>
                </div>
                <div className="action-form-wrap pt20">
                  <div className="box-bottom">
                    <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this)}><span>Đóng</span></Link>
                  </div>
                </div>
              </Dialog>
            </td>
            <td>{get(item, 'donViInfo.ten') || ''}</td>
            <td className='txt-center'>{get(item, 'quyetDinhPheDuyetKTTT') || ''}</td>
            <td rowSpan={cuocThanhTras.length}>{namThanhTra || ''}</td>
            {/* Tạm ẩn tên cuộc thanh tra/ số đối tượng */}
            {/* <td>
              <Link className='txt-underline text-color-default' to={`/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/${get(item, 'idCuocThanhTra')}`}>
                {
                  !isEmpty(item.tenCuocThanhTra) &&
                  <TextTruncate
                    line={3}
                    truncateText="…"
                    text={get(item, 'tenCuocThanhTra')} />
                }
              </Link>
              <div className='mt10'>{get(item, 'soDoiTuong')} đối tượng</div>
            </td> */}
            <td className='bg-white'>
              {get(item, 'noiDungThanhTra') || ""}
            </td>
            <td className='bg-white'>
              {get(item, 'loaiCuoc.value') == 'KIEM_TRA' ? 'Kiểm tra' : "Thanh tra"}
            </td>
            <td className='bg-white'>
              {get(item, 'kyThanhTra') || ""}
            </td>
            <td className='bg-white'>
              {get(item, 'thoiGianTienHanh') || ""}
            </td>
            <td>
              <p>{get(item, 'trangThaiXuLyTrungTaiDonViInfo.text', '')}</p>
              <p className='txt-danger mt10'>{get(item, 'uuTien.label') ? `(${get(item, 'uuTien.label')})` : ''}</p>
            </td>
          </tr>
        )
      }
      return (
        <tr key={index}>
          <td className='bg-white txt-left'>{get(item, 'donViInfo.ten') || ''}</td>
          <td className='bg-white txt-center'>{get(item, 'quyetDinhPheDuyetKTTT') || ''}</td>
          {/* Tạm ẩn tên cuộc thanh tra/ số đối tượng */}
          {/* <td className='bg-white'>
            <Link className='txt-underline text-color-default' to={`/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/${get(item, 'idCuocThanhTra')}`}>
              {
                !isEmpty(item.tenCuocThanhTra) &&
                <TextTruncate
                  line={3}
                  truncateText="…"
                  text={get(item, 'tenCuocThanhTra')} />
              }
            </Link>
            <div className='mt10'>{get(item, 'soDoiTuong')} đối tượng</div>
          </td> */}
          <td className='bg-white'>
            {get(item, 'noiDungThanhTra') || ""}
          </td>
          <td className='bg-white'>
            {get(item, 'loaiCuoc.value') == 'KIEM_TRA' ? 'Kiểm tra' : "Thanh tra"}
          </td>
          <td className='bg-white'>
            {get(item, 'kyThanhTra') || ""}
          </td>
          <td className='bg-white'>
            {get(item, 'thoiGianTienHanh') || ""}
          </td>
          <td className='bg-white'>
            <p>{get(item, 'trangThaiXuLyTrungTaiDonViInfo.text', '')}</p>
            <p className='txt-danger mt10'>{get(item, 'uuTien.label') ? `(${get(item, 'uuTien.label')})` : ''}</p>
          </td>
        </tr>
      )
    })
    return (
      <tbody className="table-body">
        {ListData}
      </tbody>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/datatable/RowItemDanhMucCuocThanhTraTrung.jsx